<template>
  <div class="funnels-item">
    <div class="funnels__text--wrap">
      <div class="text-step--wrap">
        <span class="num">{{ itemIndex + 1 }}</span>
      </div>
      <ui-tooltip class="stop-alert" arrowTop arrowCenter noApplyCenterAnimate v-show="item.state === 'stop'">
        <span class="icon icon--stop"></span>
        {{ $t('funnel.funnelsItem.stopDataCollection.tooltipShort') }}
      </ui-tooltip>
      <div class="step__info--wrap">
        <ui-tooltip class="step__title" arrowBottom arrowCenter noApplyCenterAnimate v-show="showStepName">
          {{ item.name }}
        </ui-tooltip>
        <div class="img_thumb" :style="thumbImageStyle" @mouseenter="showStepName = true" @mouseleave="showStepName = false"></div>
        <div class="info_data">
          <span class="badge_icon" v-if="isLastItem">
            {{ $t('funnel.funnelsItem.conversionRate') }}
          </span>
          <span class="txt_percent">{{ remain | fixed(1) }} <span class="txt_item">%</span></span>
          <ui-button
            class="link_share"
            :iconName="'icon--share'"
            :circle="true"
            @click.prevent="onShowFlowClick(item)">
          </ui-button>
        </div>
      </div>
    </div>
    <div class="box--data__wrap">
      <template v-if="sessionCount">
        <span class="box--wrap" v-if="pathItem.newPath"
          :style="newPercentageStyle">{{ item.newPercentage | fixed(1) }}%</span>
        <span class="box--wrap box--wrap_type2" v-if="pathItem.revisitPath"
          :style="revisitPercentageStyle">{{ item.revisitPercentage | fixed(1) }}%</span>
      </template>
      <svg width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none">
        <path v-if="pathItem.newPath" :d="pathItem.newPath" fill="#9fce12"/>
        <path v-if="pathItem.revisitPath" :d="pathItem.revisitPath" fill="#1199af"/>
        <path d="M 100 0 L 100 100" class="vline"/>
      </svg>
    </div>
    <div class="view__info--wrap">
      <div class="status--wrap" v-if="!isLastItem">
        <span class="status_icon" :class="dropOffIconClass"></span>
        <span class="status_num">{{ dropOffRate | fixed(1) }} <span class="txt">%</span> </span>
      </div>
      <div class="info__wrap">
        <a href="#none" v-if="isLastItem"
          class="link_info link_converted" :class="{ disable: !isExactMatchType }"
          @click.prevent="onConversionClick(item, true, true)"><span class="icon--converted"></span>
          {{ $t('common.converted') }}
        </a>
        <template v-else>
          <a href="#none" class="link_info" :class="{ disable: !isExactMatchType }"
            @click.prevent="onConversionClick(item, false, false)">
            {{ $t('common.inflow') }}
          </a>
          <a href="#none" class="link_info" :class="{ disable: !isExactMatchType }"
            @click.prevent="onConversionClick(item, true, false)">
            {{ $t('common.dropped') }}
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import FunnelsItemMixin from './FunnelsItemMixin'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'FunnelsItemTypeC',
  components: {
    UiButton
  },
  mixins: [
    FunnelsItemMixin
  ],
  data () {
    return {
      showStepName: false
    }
  }
}
</script>

<style scoped>
  .bubble {
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
  }
  .miniType .bubble {
    top: -100px;
  }
</style>
